import React, { useState } from 'react';
import comment from '../../assets/comment.png';
import like from '../../assets/heart.png';

export default function CardFriend(props) {

    return (
        <div>
            <button className='friend-card'>
                <div className='friend-name-container text-card'>
                    <span className='photo-container'>
                        <img className='photo-friend' src={props.image} alt="photo friend" />
                    </span>
                    <div>
                        <p className='text-name-friend'>{props.name}</p>
                        <p className='text-name-perfil'>{props.perfil}</p>
                    </div>
                </div>

                <div className='friend-social-container'>
                    <div className='friend-name-container text-card'>
                        <span className='photo-container'>
                            <img className='icon' src={comment} alt="photo friend" />
                        </span>
                        <div>
                            <p className='text-icon'>{props.comments}</p>
                        </div>
                    </div>
                    <div className='friend-name-container text-card'>
                        <span className='photo-container'>
                            <img className='icon-heart' src={like} alt="photo friend" />
                        </span>
                        <div>
                            <p className='text-icon'>{props.likes}</p>
                        </div>
                    </div>
                </div>
            </button>
        </div>
    )
}